import { sendAmplitudeEvent, sendGoogleEvent } from '@html/_common/utils';

export default function SerpBanner() {
  const handleGoogleEvent = (banner) => {
    const action = banner.data('ga-action');
    const label = banner.data('ga-label');
    const bannerName = banner.data('banner-type');
    const ctaLink = banner.data('cta-link');
    sendGoogleEvent(
      'SERP',
      action,
      label,
      {
        ampEventName: 'serp-banner-clicked',
        banner_name: bannerName,
        linked_page: ctaLink,
      },
    );
  };

  const handleAmplitudeEvent = () => {
    sendAmplitudeEvent({ ampEventName: 'srp_banner_tr_plus_learn_more_clicked' });
  };

  this.initiate = () => {
    const $serpTourList = $('.js-serp-tour-list');

    $serpTourList.on('click', '.js-serp-banner', (event) => handleGoogleEvent($(event.currentTarget)));
    $serpTourList.on('click', '.js-am-serp-banner-membership__more', handleAmplitudeEvent);
  };
}
